import React, { useMemo } from 'react';
import { ViewContextProvider } from '../Context/ViewContext';
import { SalesOrderFormByAllocation } from '../../views/sales/salesOrderForm/SalesOrderForm';
import PurchaseOrderCancelReceiptForm from '../../views/purchases/PurchaseOrderCancelReceiptForm';

const LazyGoodsReceiptForm = React.lazy(() => import('../../views/product/ProductsGoodsReceiptForm'));
const LazyStockAdjustmentForm = React.lazy(() => import('../../views/product/ProductsStockAdjustmentForm'));
const LazyStockTransferForm = React.lazy(() => import('../../views/product/ProductsStockTransferForm'));

export const supportedDocumentTypes = [
  'GOODS_RECEIPT',
  'STOCK_ADJUSTMENT',
  'STOCK_TRANSFER',
  'ALLOCATION',
  'PURCHASE_ORDER_RECEIPT_ADJUSTMENT',
];

function getSalesOrderTab(stockTransactionReason) {
  switch (stockTransactionReason) {
    case 'DISPATCH':
    case 'CANCEL_DISPATCH':
      return 'dispatch';
    default:
      return undefined;
  }
}

const StockTransactionModal = (props) => {
  let content = null;

  const {
    rowData: { documentType, sourceId, stockTransactionReason },
  } = props;

  const { overrideParams, ...rest } = props;

  switch (documentType) {
    case 'GOODS_RECEIPT':
      content = <LazyGoodsReceiptForm {...props} />;
      break;
    case 'STOCK_ADJUSTMENT':
      content = <LazyStockAdjustmentForm {...props} />;
      break;
    case 'STOCK_TRANSFER':
      content = <LazyStockTransferForm {...props} />;
      break;
    case 'ALLOCATION':
      content = (
        <SalesOrderFormByAllocation
          {...rest}
          match={{ params: { allocationId: sourceId } }}
          forceReadOnly={true}
          activeTabId={getSalesOrderTab(stockTransactionReason)}
        />
      );
      break;
    case 'PURCHASE_ORDER_RECEIPT_ADJUSTMENT':
      content = <PurchaseOrderCancelReceiptForm {...props} forceReadOnly={true} />;
      break;
  }

  const viewContext = useMemo(
    () => ({
      uniqueName: 'StockTransactionModal',
    }),
    []
  );

  //Overriding the view context because otherwise grids in forms in this modal can have shimmer rows or similar unexpectedly applied.
  return <ViewContextProvider value={viewContext}>{content}</ViewContextProvider>;
};

export default StockTransactionModal;
